import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  // Private subject to control the loader state

  isLoading = new BehaviorSubject<boolean>(false);


  show() {
    this.isLoading.next(true)
  }
  dismiss(){
    this.isLoading.next(false)
  }

}
